import { Button } from "@libertify/ui";
import { useTranslate } from "@refinedev/core";
import { useAntTheme } from "hooks/useAntTheme/";
import { CSSProperties } from "react";

export const GenerateButton = ({ style }: { style?: CSSProperties }) => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  return (
    <Button
      style={{
        marginTop: 12,
        color: theme.colorBgBase,
        borderColor: theme.colorPrimary,
        ...style,
      }}
    >
      {t("projects.components.ProjectCreationPage.generateMyExperience")}
    </Button>
  );
};
